module.exports = __webpack_public_path__ + "static/media/kitty1.d0d102ba.jpg";